<template>
    <div class="page-setting has-bc biz-edit-account-comp">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <button class="default-button publish" @click="saveData">儲存設定</button>
            </div>
        </div>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                帳密
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        員工帳號
                        </div>
                        <div class="biz-table-content">
                            {{insertData.email?insertData.email:'-'}}
                        </div>
                    </div>
                </div>
                <!-- <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 電子郵件帳號
                        </div>
                        <span v-show="error.email" class="error-with-title">{{error.email}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.email}" type="text" v-model="insertData.email" placeholder="請輸入電子郵件帳號">
                    </div>
                </div> -->
                <!-- <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 密碼
                        </div>
                        <span v-show="error.password" class="error-with-title">{{error.password}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.password}" type="text" v-model="insertData.password" placeholder="請輸入密碼">
                    </div>
                </div> -->
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                基本資料
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 員工真實姓名
                        </div>
                        <span v-show="error.name" class="error-with-title">{{error.name}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.name}" type="text" v-model="insertData.name" placeholder="請輸入員工真實姓名">
                        <div class="input-note" @mouseenter="tipStatus.agent=true" @mouseleave="tipStatus.agent=false">員工姓名會呈現在哪裡？</div>
                        <title-tips v-if="tipStatus.agent" class="tips-agent" title="廣告頁面的聯絡人" width="424px">
                            <div class="content" slot="content">
                                <div class="ad-title">
                                    廣告名稱
                                </div>
                                <div class="rent">
                                    28,000 <span class="unit">元 / 月</span>
                                </div>
                                <div class="agent">
                                    <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                                    <div class="name">{{insertData.name?insertData.name:'員工姓名'}}</div>
                                    <div class="phone">{{insertData.phoneNumber?insertData.phoneNumber:'0912345678'}}</div>
                                    <img src="@/assets/img/icon/phone_blue.svg" alt="">
                                </div>
                            </div>
                        </title-tips>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 手機號碼
                        </div>
                        <span v-show="error.phoneNumber" class="error-with-title">{{error.phoneNumber}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.phoneNumber}" type="text" v-model="insertData.phoneNumber" placeholder="請輸入手機號碼">
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                分配群組
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 職務部門
                        </div>
                        <span v-show="error.roleId" class="error-with-title">{{error.roleId}}</span>
                    </label>
                    <div class="input-arear">
                        <rent-select class="select-scroll" :key="'role'+componentKey" :class="{error: error.roleId}" refName="role" :selectMsg="accountInfo.roleName?accountInfo.roleName:'請選擇職務部門'" @getId="getSelectId"  bgColor="#fff">
                            <ul>
                                <li v-for="(list, index) in employeeRoleList" :key="index" :data-id="list.id" :data-name="list.roleName">
                                    {{list.roleName}}
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 業務分群
                        </div>
                        <span v-show="error.groupId" class="error-with-title">{{error.groupId}}</span>
                    </label>
                    <div class="input-arear">
                        <div v-if="accountInfo.manager" @click="eventRules('管理者不能改分群')" class="not-allow"></div>
                        <div v-else-if="accountInfo.hasHouse" @click="eventRules('員工尚有房源，不能改分群')" class="not-allow"></div>
                        <rent-select class="select-scroll" :key="'group'+componentKey" :class="{error: error.groupId}" refName="group" :selectMsg="accountInfo.groupName?accountInfo.groupName:'請選擇業務分群'" @getId="getSelectId" bgColor="#fff">
                            <ul>
                                <li v-for="(list, index) in organizationGroupList" :key="index" :data-id="list.id" :data-name="list.groupName">
                                    {{list.groupName}}
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import titleTips from '@/components/bussiness/widges/tips/titleTips.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            componentKey: 0,
            insertData: {
                email: '',
                // password: null,
                name: '',
                phoneNumber: '',
                roleId: '',
                groupId: '',
                userId: '',
            },
            error: {
                email: null,
                // password: null,
                name: null,
                phoneNumber: null,
                roleId: null,
                groupId: null,
            },
            tipStatus: {
                agent: false
            },
        }
    },
    mounted () {
        // 取得角色列表
        this.getEmployeeRoleList();
        // 取得分群列表
        this.getOrganizationGroupList();
        // 取得詳細
        this.getInfo(this.$route.query.cId)
        this.insertData.userId = this.$route.query.cId
    },
    watch: {
        insertData: {
            handler: function (newValue, oldValue) {
                // email信箱驗證
                if(newValue.email){
                    let isMail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
                    if (!isMail.test(newValue.email)) {
                        this.error.email = '電子郵件格式錯誤';
                    }else{
                        this.error.email = null;
                    }
                }
                // 密碼驗證
                if(newValue.password){
                    let isText = /^(?=.*\d)(?=.*[a-zA-Z]).{8,30}$/;
                    if (!isText.test(newValue.password)) {
                        this.error.password = '需包含英文加上數字八位字元';
                    }else{
                        this.error.password = null;
                    }
                }
            },
            deep: true,
        },
        accountInfo: {
            handler: function (newValue, oldValue) {
                this.componentKey += 1
                this.insertData.email = this.accountInfo.account
                this.insertData.name = this.accountInfo.name
                this.insertData.phoneNumber = this.accountInfo.phoneNumber
                this.insertData.roleId = this.accountInfo.roleId
                this.insertData.groupId = this.accountInfo.groupId
            },
            deep: true,
        }
    },
    methods: {
        getEmployeeRoleList: function () {
            this.$store.dispatch('getBizEmployeeRoleList')
        },
        getOrganizationGroupList: function () {
            this.$store.dispatch('getBizOrganizationGroupList')
        },
        getInfo: function (id) {
            this.$store.dispatch('getBizAccountInfo', id)
        },
        checkInput: function () {
            if(this.insertData.email == ''){
                this.error.email = '請填寫電子郵件帳號';
            }else{
                this.error.email = null;
            }
            if(this.insertData.name == ''){
                this.error.name = '請填寫員工真實姓名';
            }else{
                this.error.name = null;
            }
            if(this.insertData.phoneNumber == ''){
                this.error.phoneNumber = '請填寫手機號碼';
            }else{
                this.error.phoneNumber = null;
            }
            if(this.insertData.roleId == ''){
                this.error.roleId = '請選擇職務部門';
            }else{
                this.error.roleId = null;
            }
            if(this.insertData.groupId == ''){
                this.error.groupId = '請選擇業務分群';
            }else{
                this.error.groupId = null;
            }

            if(this.error.email == null && 
                // this.error.password == null &&
                this.error.name == null &&
                this.error.phoneNumber == null && 
                this.error.roleId == null &&
                this.error.groupId == null &&
                this.insertData.email != '' &&
                this.insertData.name != '' &&
                this.insertData.phoneNumber != '' && 
                this.insertData.roleId != '' &&
                this.insertData.groupId != ''){
                return true 
            }else{
                return false
            }
        },
        saveData: function () {
            if(this.checkInput()){
                this.$analyticsBiz.logEvent('編輯帳號', { screen_name: '編輯帳號'})

                this.$store.dispatch('editBizAccount', this.insertData)
                .then(res => {
                    if( res.data.status == "SUCCESS" ){
                        this.$router.push({ name: 'bizAccountMgt'})
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
            }
        },
        getSelectId: function (value) {
            let targetId = value.id
            if( value.ref == 'role' ){
                this.insertData.roleId = targetId
            }else if( value.ref == 'group'){
                this.insertData.groupId = targetId
            }
        },
        eventRules: function (msg) {
            // // let arrears = true
            // let isManager = this.accountInfo.manager
            // let isHasHouse = this.accountInfo.hasHouse
            // if(isManager && event === 'manager'){
            this.$store.dispatch('setAlarmStatus', {status: true,title: msg,type: 'error', closeBtn: true})
            // }else if(isHasHouse && event === 'house'){
            //     this.$store.dispatch('setAlarmStatus', {status: true,title: msg,type: 'error', closeBtn: true})
            // }
        },
    },
    computed: {
        ...mapGetters({
            employeeRoleList: 'GET_BIZ_EMPLOYEE_ROLE_LIST',
            organizationGroupList: 'GET_BIZ_ORGANIZATION_GROUP_LIST',
            accountInfo: 'GET_BIZ_ACCOUNT_INFO',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        toogleBlock,
        RentSelect,
        titleTips
    }
}
</script>
<style lang="scss">
    .biz-edit-account-comp{
        padding-bottom: 300px;
        .toggle-block > .toogle-body {
            padding: 0 60px 24px 24px;
            .tips-agent{
                font-size: 20px;
                font-weight: 500;
                .ad-title{
                    margin-bottom: 10px;
                }
                .rent{
                    color: #a19d9c;
                    margin-bottom: 16px;
                    .unit{
                        font-size: 14px;
                    }
                }
                .agent{
                    display: flex;
                    align-items: center;
                    .name{
                        color: #fc7171;
                        margin-left: 8px;
                        margin-right: 12px;
                    }
                    .phone{
                        margin-right: 10px;
                        color: #3a455f;
                    }
                }
            }
        }
        .not-allow{
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 3;
        }
        .must-fill-alarm{
            position: relative;
            display: flex;
            align-items: center;
            height: 72px;
            margin-bottom: 20px;
            border-radius: 6px;
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            color: #676362;
            padding: 0 24px;
            .star{
                color: #fc7171;
                margin: 0 2px;
            }
            img{
                margin-right: 2px;
            }
        }
        span.error{
            right: 0;
            top: -27px;
            left: unset;
            bottom: unset;
        }
        .row-block {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .col2-input {
            position: relative;
            width: 424px;
            margin-bottom: 24px;
        }
        .name-note {
            margin-top: 8px;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            color: #3942b5;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/internalAuth/accountMgt/editAccountComp.vue